/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export interface IMealSchedule {
  id?: string;
  name?: string;
  tmValue?: string;
  timestampentry?: number;
  lastupdated?: number;
  microSec?: number;
  shortCode?: string;
  lang?: string;
  sortOrder?: string;
  active?: boolean;
}

export const defaultValue: Readonly<IMealSchedule> = {
  active: false,
};
